import { useQuery } from '@tanstack/react-query';

import { FilterSchema } from '@/api';

import { useHistorischBesluit } from '../historischBesluit';

type HistorischBesluitByLineageIdParams = {
  voorschriftLineageId: string;
};

const buildHistorischBesluitByLineageIdParams = ({
  voorschriftLineageId,
}: HistorischBesluitByLineageIdParams) => ({
  page: 1,
  size: 1,
  filter: [
    {
      field: 'Voorschrift_lineage',
      op: 'eq',
      value: voorschriftLineageId,
      model: 'VoorschriftHistorischBesluit',
    },
  ] satisfies FilterSchema[],
});

const getHistorischBesluitByLineageIdQueryOptions = ({
  voorschriftLineageId,
}: HistorischBesluitByLineageIdParams) =>
  useHistorischBesluit.getOptions(
    buildHistorischBesluitByLineageIdParams({ voorschriftLineageId }),
    { select: ({ objects }) => objects?.[0] }
  );

const getHistorischBesluitByLineageIdQueryOptionsSuspense = ({
  voorschriftLineageId,
}: HistorischBesluitByLineageIdParams) =>
  useHistorischBesluit.getSuspenseOptions(
    buildHistorischBesluitByLineageIdParams({ voorschriftLineageId }),
    { select: ({ objects }) => objects?.[0] }
  );

const useHistorischBesluitByLineageId = (
  props: HistorischBesluitByLineageIdParams
) => useQuery(getHistorischBesluitByLineageIdQueryOptions(props));
useHistorischBesluitByLineageId.options =
  getHistorischBesluitByLineageIdQueryOptions;
useHistorischBesluitByLineageId.getSuspenseOptions =
  getHistorischBesluitByLineageIdQueryOptionsSuspense;

export { useHistorischBesluitByLineageId };
